import {studentTypes} from "../actions/_student_actions";

const studentReducerDefaultState = {};

export default (state = studentReducerDefaultState, action) => {
    switch (action.type) {
        case studentTypes.LOAD_PROFILE:
            return {
                profile: action.profile
            }
        default:
            return state;
    }
}